import React, { useState } from 'react';
import SidebarStatuses from "../Sidebar/components/SidebarStatuses/SidebarStatuses";
import Sidebar from "../Sidebar/Sidebar";

type StatusFiltersSidebarPropTypes = {
    onAfterStatusSelect?: () => void;
};

const StatusFiltersSidebar = ({ onAfterStatusSelect }: StatusFiltersSidebarPropTypes) => {
    const [showProfile, setShowProfile] = useState(true);

    return (
        <Sidebar>
            {/* {!isMobileOrTablet() && showProfile && <SidebarProfile />} */}
            <SidebarStatuses
                setShowProfile={setShowProfile}
                onAfterStatusSelect={onAfterStatusSelect}
            />
        </Sidebar>
    );
};

export default StatusFiltersSidebar;